<div class="section-header" [ngClass]="{ 'section-header-thick-underline': underlineThickness === 'thick', 'primary': type === 'primary' }" [class]="class">
  <ng-content></ng-content>
</div>